import { Controller } from "stimulus"
import MetaPreview from '../lib/meta'

export default class extends Controller {
  connect() {
    const parentElt = this.element
    keep43ForAll(parentElt)
    window.addEventListener('resize', ()=>keep43ForAll(parentElt))
    checkAvailableThread(parentElt)
    previewLinks(parentElt.querySelectorAll('a[data-preview]'))
    fixVideoSources()
  }

  showTweet(evt) {
    const {screenname, tweet} = evt.currentTarget.dataset
    const doDefaultClick = eltHasClass(evt.target, ['content-tweet','t-main','t-tweet']) || evt.target.tagName == 'I'
    if (doDefaultClick && !getSelection().toString()) {
      window.open(`https://twitter.com/${screenname}/status/${tweet}`, '_blank')
    }
  }
}

const eltHasClass = (elt, classArray)=>
  classArray.find(classname=>elt.classList.contains(classname))

function keep43Ratio(elt) {
  elt.style.height = elt.scrollWidth*3/4 + 'px'
}

function keep43ForAll(parentElt) {
  parentElt.querySelectorAll('.keep-ratio-4-3').forEach(elt=>keep43Ratio(elt))
}

async function availableTraId(statusId) {
  try {
    const r = await fetch(`/api/v0/ping/${statusId}.json`)
    const result = await r.json()
    console.log('got pong', result.pong)
    return result.pong  
  }
  catch (e) {
    return null
  }
}

async function checkAvailableThread(parentElt) {
  const currentThreadMatch = window.location.pathname.match(/^\/thread\/(\d+)/)
  const currentThreadId = currentThreadMatch && currentThreadMatch[1]

  parentElt.querySelectorAll('.twitter-player a').forEach(async anchorElt=>{
    const link = anchorElt.href
    const twitterSpan = anchorElt.closest('.twitter-player')
    const match = link && link.match(/^https?:\/\/(x|twitter)\.com\/\w{1,15}\/status\/(\d+)/)
    if (twitterSpan && match && match[2]) {
      const statusId = match[2]
      const availableId = await availableTraId(statusId)
      if (availableId && availableId !== currentThreadId) {
        const url = `/thread/${availableId}.html`
        if (!twitterSpan.previousElementSibling?.classList.contains('ribbon-content')) {
          const ribbonContent = document.createElement('div')
          ribbonContent.className = 'ribbon-content'

          const ribbon = document.createElement('div')
          ribbon.className = 'ribbon base'

          const span = document.createElement('span')

          const anchor = document.createElement('a')
          anchor.href = url
          anchor.textContent = 'Unroll available on Thread Reader'

          span.appendChild(anchor)
          ribbon.appendChild(span)
          ribbonContent.appendChild(ribbon)

          twitterSpan.parentNode.insertBefore(ribbonContent, twitterSpan)
        }
      }
    }
  })
}

function previewLinks(links) {
  const linksArray = Array.prototype.slice.call(links)
  const existingUrls = []
  const uniqueLinks = linksArray.filter((link, index, self)=>{
    const url = link.getAttribute('href')
    if (existingUrls.includes(url)) {
      return false
    }
    else {
      existingUrls.push(url)
      return true
    }
  })
  uniqueLinks.forEach(link=>MetaPreview.fetchAndCreate(link))
}

// Fix Twitter video URLs by stripping the ?tag=XX parameter and adding no-referrer policy
// Twitter CDN now rejects requests containing this parameter and blocks non-Twitter referrers (as of Dec 2025)
function fixVideoSources() {
  // Add no-referrer meta tag to prevent Twitter from blocking based on Referer header
  if (!document.querySelector('meta[name="referrer"]')) {
    const meta = document.createElement('meta')
    meta.name = 'referrer'
    meta.content = 'no-referrer'
    document.head.appendChild(meta)
  }

  // Fix all videos on the page (not just inside the controller element)
  document.querySelectorAll('video').forEach(video => {
    let hasTwitterVideo = false

    video.querySelectorAll('source').forEach(source => {
      const src = source.getAttribute('src')
      if (src && src.includes('video.twimg.com')) {
        hasTwitterVideo = true
        try {
          const url = new URL(src)
          if (url.searchParams.has('tag')) {
            url.searchParams.delete('tag')
            source.src = url.toString()
          }
        } catch (e) {
          // Fallback for invalid URLs - use regex
          if (/[?&]tag=\d+/.test(src)) {
            const cleanSrc = src.replace(/[?&]tag=\d+/g, '').replace(/\?$/, '')
            source.setAttribute('src', cleanSrc)
          }
        }
      }
    })

    // Reload all Twitter videos to ensure they pick up the no-referrer meta tag
    if (hasTwitterVideo) {
      video.load()
    }
  })
}
